import { Suspense, lazy, type ComponentProps } from 'react'
import type { PhotoAnnotator } from './PhotoAnnotator'

/**
 * The annotation editor, code-split (UI plan Phase 2).
 *
 * It is a modal that most sessions never open, and the bundle budget has
 * roughly 23 kB of slack against `totalJs` — the same constraint that replaced
 * `@hello-pangea/dnd` with native drag on the Kanban board. Splitting it costs
 * one network round trip on first use and nothing at all otherwise.
 */
const PhotoAnnotatorImpl = lazy(async () => ({
  default: (await import('./PhotoAnnotator')).PhotoAnnotator,
}))

export function LazyPhotoAnnotator(props: ComponentProps<typeof PhotoAnnotator>) {
  return (
    <Suspense fallback={null}>
      <PhotoAnnotatorImpl {...props} />
    </Suspense>
  )
}
